<script setup>
import Icon from 'next/icon/Icon.vue';

defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div
    class="flex items-center gap-4 px-4 py-3 rounded-2xl min-h-[3.25rem] text-n-slate-10 select-none pointer-events-none"
  >
    <Icon v-if="icon" :icon="icon" class="size-5" />
    <span class="text-base font-semibold leading-5 flex-grow">
      {{ label }}
    </span>
  </div>
</template>
